<script setup lang="ts">
import { CarbucksLogo } from '@app/Components/CarbucksLogo';
import LicensePlate from "../Components/LicensePlate.vue";
import { storeToRefs } from "pinia";
import { useWelcomeFlowStore } from "../WelcomeFlowStore";

const welcomeFlowStore = useWelcomeFlowStore();
const errorPanelState = storeToRefs( welcomeFlowStore ).errorPanelState;


/**
 * Handles the try again button click
 * If welcome flow completion was attempted, retries completion
 * Otherwise resets the vehicle search to start over
 */
const handleTryAgain = async () => {
    if( welcomeFlowStore.completionAttempted )
    {
        await welcomeFlowStore.retryCompleteWelcomeFlowAsync();
        return;
    }

    welcomeFlowStore.resetVehicleSearch();
}

</script>

<template>
<div class="flex flex-col min-h-full p-4 overflow-y-auto pt-10">

        <LicensePlate />

        <div class="text-center text-sm mt-6 mb-4 flex flex-col gap-2 px-4">
            <div class="text-2xl uppercase text-primary-500">{{ errorPanelState.title }}</div>
            <div v-show="errorPanelState.subtitle" class="text-sm mb-2 text-primary-500">
                {{ errorPanelState.subtitle }}
            </div>
            <p class="text-sm">
                {{ errorPanelState.messageOne }}
            </p>
            <p v-show="errorPanelState.messageTwo" class="text-sm opacity-60">
                {{ errorPanelState.messageTwo }}
            </p>
        </div>
        
        <!-- The user has searched for a vehicle but thinks the details are incorrect and needs to reset the form -->
        <Button v-if="welcomeFlowStore.hasSearchedForVehicle"
                                variant="tonal"
                                color="white"
                                size="large"
                                class="w-full !h-12 lg:!h-14 mt-1"
                                @click="handleTryAgain">
            Try again
        </Button>
    </div>
</template>